import React from 'react'
import { withFormik } from 'formik'
import m from 'moment'
import styled from 'styled-components'
import { compose } from 'recompose'

import withAutoSave from '../../../modules/form/withAutoSave'
import DatePicker from '../dateTimePicker/DatePicker'
import TimePicker from '../dateTimePicker/TimePicker'

const MomentCard = ({
  title,
  values,
  handleChange,
  handleBlur,
  setFieldValue,
  isCommitting,
  isSaved,
}) => (
  <div className="card">
    <div className="card-content">
      <div className="content">
        <ModalTitle>
          <span className="title is-4">Moment</span>{' '}
          {isCommitting && <span className="subtitle is-6">SAVING...</span>}
          {isSaved && <span className="subtitle is-6">SAVED</span>}
        </ModalTitle>

        <div className="level">
          <LevelLeft>
            <LevelItem>
              <div className="field">
                <label className="label">Date</label>
                <div className="control">
                  <DatePicker
                    value={values.momentAt}
                    onChange={date => setFieldValue('momentAt', date)}
                  />
                </div>
              </div>
            </LevelItem>

            <LevelItem>
              <div className="field">
                <label className="label">Time</label>
                <div className="control">
                  <TimePicker
                    value={values.momentAt}
                    onChange={date => setFieldValue('momentAt', date)}
                  />
                </div>
              </div>
            </LevelItem>

            <LevelItem>
              <button
                className="button is-primary is-small"
                onClick={setCurrentDate(setFieldValue, 'momentAt')}
              >
                CURRENT DATE
              </button>
            </LevelItem>
          </LevelLeft>
        </div>

        <div className="field">
          <div className="control">
            <textarea
              name="message"
              value={values.message}
              onChange={handleChange}
              onBlur={handleBlur}
              className="textarea is-medium"
              placeholder="Describe your moment..."
              rows="15"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
)

const setCurrentDate = (setFieldValue, field) => () => {
  setFieldValue(field, m())
}

export default compose(
  withFormik({
    mapPropsToValues: ({ moment }) => ({
      message: moment.message,
      momentAt: m(moment.momentAt),
    }),
    handleSubmit: null,
    validate: (values, props) => {
      return {}
    },
  }),
  withAutoSave({ debounceTime: 1000 }),
)(MomentCard)

const ModalTitle = styled.div`
  > *:not(:last-child) {
    margin-right: 16px;
  }

  margin-bottom: 1rem;
`

const LevelLeft = styled.div.attrs({ className: 'level-left' })`
  align-items: flex-end !important;

  > *:not(:last-child) {
    margin-right: 1rem !important;
  }
`

const LevelItem = styled.div.attrs({ className: 'level-item' })`
  justify-content: flex-start !important;
`



// WEBPACK FOOTER //
// ./src/components/templates/momentCard/MomentCard.js